import { createApi, fetchBaseQuery, FetchBaseQueryError } from '@reduxjs/toolkit/query/react'
import { AppServices } from 'middleware'
import { CursorPaginatedResponse } from '../../types'
import { AuditLogEntry, AuditLogQuery } from './schema'

const toQueryError = (error: unknown) =>
    ({
        status: 'CUSTOM_ERROR',
        error: error instanceof Error ? error.message : 'Request failed',
    } as FetchBaseQueryError)

export const auditLogApi = createApi({
    reducerPath: 'auditLogApi',
    baseQuery: fetchBaseQuery({}),
    endpoints: () => ({}),
})

const extendedAuditLogApi = auditLogApi.injectEndpoints({
    endpoints: (builder) => ({
        listAuditLogEntries: builder.query<
            CursorPaginatedResponse<AuditLogEntry[]>,
            AuditLogQuery & { accountSlug: string }
        >({
            queryFn: async ({ accountSlug, ...query }, api) => {
                try {
                    return { data: await AppServices.auditLogService.listEntries(accountSlug, query, api.signal) }
                } catch (error) {
                    return { error: toQueryError(error) }
                }
            },
        }),
        listAuditLogActors: builder.query<string[], string>({
            queryFn: async (accountSlug, api) => {
                try {
                    return { data: await AppServices.auditLogService.listActors(accountSlug, api.signal) }
                } catch (error) {
                    return { error: toQueryError(error) }
                }
            },
        }),
    }),
})

export const { reducer, reducerPath } = auditLogApi
export const { useListAuditLogEntriesQuery, useListAuditLogActorsQuery } = extendedAuditLogApi
